$('.hc-slideshow.hc-desktop').slick({
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  fade: true,
  arrows: true,
  prevArrow: '<div class="hc-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0676/7778/2324/files/back.png?v=1712304783"></div>',
  nextArrow: '<div class="hc-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0676/7778/2324/files/next.png?v=1712304784"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
$('.hc-slideshow.hc-mobile').slick({
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
});
$(document).on('click', '.hc-product-box', function() {
  if(window.innerWidth <= 768) {
    $(this).toggleClass('hc-clicked');
  }
});
